import { useNavigate } from "react-router-dom";
import TermsOfUse from "../components/TermsOfUse";

export default function TermsOfUsePage() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <header className="bg-white shadow-sm">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-6">
                            <img
                                className="h-10 w-auto cursor-pointer"
                                src="/images/logo.png"
                                alt="Cofrim Logo"
                                onClick={() => navigate("/")}
                            />
                            <button
                                onClick={() => navigate("/")}
                                className="text-indigo-600 hover:text-indigo-800 font-medium"
                            >
                                Voltar ao início
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Content */}
            <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white rounded-lg shadow-sm p-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                        Termos de Uso
                    </h1>
                    
                    <div className="prose prose-lg max-w-none">
                        <TermsOfUse />
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-white border-t border-gray-200 mt-12">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="text-center text-gray-500 text-sm">
                        <p>&copy; {new Date().getFullYear()} Cofrim. Todos os direitos reservados.</p>
                        <div className="mt-2 space-x-4">
                            <button
                                onClick={() => navigate("/politica-de-privacidade")}
                                className="text-indigo-600 hover:text-indigo-800"
                            >
                                Política de Privacidade
                            </button>
                            <span>•</span>
                            <span className="text-gray-400">Termos de Uso</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}